// @flow weak

import { appConfig } from '../../config';
import {
  jsonHeaderAuth,
  refreshAuthLogic
} from '../fetchTools';
import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
export const getTop10Device = async (cnumb) => {
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const url = `${appConfig.BASE_API}/count/toptendevice/${cnumb}`;
    
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
  
};

export const getTop10DeviceGCS = async (cnumb) => {
  const url = `${appConfig.BASE_API}/count/toptendevicegcs/${cnumb}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
    
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const getDeviceByCustNumb = async (numb) => {
  const url = `${appConfig.BASE_API}/device/readall/${numb}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
    
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const getLogDevice = async (sn) => {
  const url = `${appConfig.BASE_API}/logdevice/readbysn/${sn}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
    
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const getDevice = async (sn) => {
  const url = `${appConfig.BASE_API}/device/${sn}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
    
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const getDeviceGCSByCustNumb = async (numb) => {
  const url = `${appConfig.BASE_API}/devicegcs/readall/${numb}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const getLogDeviceGCS = async (sn) => {
  const url = `${appConfig.BASE_API}/logdevicegcs/readbysn/${sn}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const getDeviceGCS = async (sn) => {
  const url = `${appConfig.BASE_API}/devicegcs/${sn}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const getDeviceGCSStatus = async (sn) => {
  const url = `${appConfig.BASE_API}/devicegcs/status/${sn}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const getDeviceStatus = async (sn) => {
  const url = `${appConfig.BASE_API}/device/status/${sn}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const logRangeDevice = async (cnumb, req) => {
  const url = `${appConfig.BASE_API}/logdevice/range/${cnumb}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const searchDeviceBySNEQ = async (req) => {
  const url = `${appConfig.BASE_API}/device/search`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const logRangeDeviceGCS = async (cnumb, req) => {
  const url = `${appConfig.BASE_API}/logdevicegcs/range/${cnumb}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const logRangebySnDevice = async (cnumb, req) => {
  const url = `${appConfig.BASE_API}/logdevice/rangebysn/${cnumb}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const logRangebySnDeviceGCS = async (cnumb, req) => {
  const url = `${appConfig.BASE_API}/logdevicegcs/rangebysn/${cnumb}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const updateBoundary = async (req) => {
  const url = `${appConfig.BASE_API}/device/updateboundary`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const updateBoundaryGCS = async (req) => {
  const url = `${appConfig.BASE_API}/devicegcs/updateboundary`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
   .catch (error=> {
    return null;
  })
  return result
};

export const updatePicDeviceEDS = async (req) => {
  const url = `${appConfig.BASE_API}/device/updatePIC`; 
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    if (res.status==200)
      return true
    else
      return false
    
    })    
   .catch (error=> {
    // console.log('error', error)
    return false;
  })
  return result
};

export const updatePicDeviceGCS = async (req) => {
  const url = `${appConfig.BASE_API}/devicegcs/updatePIC`; 
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    if (res.status==200)
      return true
    else
      return false
    
    })    
   .catch (error=> {
    // console.log('error', error)
    return false;
  })
  return result
};

export const searchHistorySN = async (req) => {
  const url = `${appConfig.BASE_API}/HistorySN/search/`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};